module.exports = __webpack_public_path__ + "fontawesome-webfont.912ec66d7572ff821749.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/sung/WebstormProjects/exafe front/resources/font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0
// module id = ../../../../../resources/font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0
// module chunks = 2